/* @flow */
import React from 'react';

import Navigation from 'components/UIKit/Details/Navigation';
import NavItem from 'components/UIKit/Details/Navigation/NavItem';
import TransactionIcon from 'components/icons/TransactionIcon';
import DetailsIcon from 'components/icons/DetailsIcon';
import DownloadIcon from 'components/icons/DownloadIcon';
import TreeIcon from 'components/icons/TreeIcon';

export default function TransactionDetailsNavigation({
  details, active, handleOnClick
}: any): React.Element {
  let type = <TransactionIcon type={details.item.type} />;

  const txType = details.item.type;
  return (
    <Navigation details={details} type={type} active={active} handleOnClick={handleOnClick}>
      <NavItem spyId="actions" tooltip={{text: 'Actions'}}>
        <DownloadIcon />
      </NavItem>
      <NavItem spyId="details" tooltip={{text: 'Information'}}>
        <DetailsIcon />
      </NavItem>
      { txType !== 'release' &&
        <NavItem spyId="types" tooltip={{text: 'Types'}}>
          <TreeIcon />
        </NavItem>
      }
      { txType !== 'release' &&
        <NavItem spyId="documents" tooltip={{text: 'Documents'}}>
          <i className="material-icons">description</i>
        </NavItem>
      }
    </Navigation>
  );
}
